module.exports = function getResource(label, vars = []) {
    const resources = {
        unsubscribeModalConfirmTitle: 'Désabonné',
        unsubscribeModalConfirmMsg: 'Vous avez réussi à vous désabonner de votre article à réapprovisionnement automatique.',
        unsubscribeModalConfirmButtonText: 'Terminé',
        errorMessage: 'Oups! Un problème est survenu et nous n’avons pas été en mesure de traiter vos modifications. Veuillez réessayer plus tard.',
        manageSubscription: 'Gérer l’abonnement',
        unsubscribeItem: 'Se désabonner de l’article',
        updateSubscriptionError: 'Mettre à jour l’abonnement',
        pausedSubscriptionModalConfirmTitle: 'Article en pause',
        pausedSubscriptionModalConfirmMsg: 'Le réapprovisionnement automatique de cet article a été mis en pause. Vous pouvez sélectionner « Reprendre » à tout moment pour reprendre la livraison.',
        pausedSubscriptionModalConfirmButtonText: 'Terminé',
        skipItemUnavailable: '« Sauter l’article » n’est pas disponible',
        skipedSubscriptionModalConfirmTitle: 'Article sauté',
        nextShipmentText: 'Le réapprovisionnement automatique de votre article sautera la prochaine livraison et reprendra le',
        pause: 'En pause',
        getItSoonerUpdateTitle: 'Mise à jour de l’abonnement Obtenez-le plus rapidement',
        getItSoonerConfirmationTitle: 'Article ajouté au panier',
        getItSoonerConfirmationContent: 'L’article a été ajouté à votre panier. Vous serez maintenant dirigé vers votre panier',
        getItSoonerConfirmButtonText: 'Terminé',
        resumeItem: 'Reprendre l’article',
        deleteCard: 'Supprimer la carte',
        addNewCard: 'Ajoutez une nouvelle carte de crédit ou de débit',
        editCard: 'Modifier la carte de crédit ou de débit',
        pauseItem: 'Mettre l’article en pause',
        addressRemovalModalTitle: 'Supprimer l’adresse',
        addressRemovalModalBody: 'Êtes-vous sûr(e) de vouloir supprimer cette adresse?',
        addressRemovalModalConfirmButtonText: 'Supprimer l’adresse',
        addressRemovalModalFailureButtonText: 'OK',
        addressRemovalModalBodyFailure: 'Impossible de supprimer l’adresse. Cette adresse est utilisée en tant que\n' +
            'votre adresse pour un abonnement. Pour la supprimer, changez l’adresse liée à l’abonnement.',
        limitReachedTitle: 'Maximum atteint',
        limitReachedBody: 'Veuillez supprimer l’une de vos adresses enregistrées avant d’en ajouter une nouvelle.',
        limitReachedConfirmButtonText: 'OK',
        orderConfirmationTitle: 'Order Confirmation',
        orderConfirmationBody: `Thank you! Your order number is #${vars[0]}. You’ll receive a confirmation email at <b>${vars[1]}</b>`,
        orderConfirmationConfirmButtonText: 'Got It',
        orderConfirmationErrorTitle: 'Unable to Update',
        orderNowTooSoonTitle: 'Too Soon to Reorder',
        orderNowTooSoonBody: `You've already placed a Get It Now order in the last ${vars[0]} days. Please come in ${vars[1]} days to order again.`
    };
    return resources[label];
};
